export default __webpack_public_path__ + "graphics/parlor.8f35b1f6.svg";